import { Activity, Gauge, Radio, TimerReset, Zap } from 'lucide-react'
import type { MutationRecord } from '../core/store'
import type { PreviewMetric } from './SandboxPreview'

interface PerformancePanelProps {
  previewMetric: PreviewMetric
  mutations: MutationRecord[]
  firstTokenMs: number | null
  historyDepth: number
}

export function PerformancePanel({
  previewMetric,
  mutations,
  firstTokenMs,
  historyDepth,
}: PerformancePanelProps) {
  const lastMutation = mutations.at(-1)
  const interactionMs = lastMutation?.durationMs ?? 0
  const frameBudget = Math.min(100, (previewMetric.renderMs / 16.7) * 100)

  return (
    <div className="performance-content">
      <section className="perf-score">
        <div className="score-ring"><strong>98</strong><span>/ 100</span></div>
        <div><span>Interaction health</span><p>All live budgets passing</p></div>
      </section>
      <div className="metric-grid">
        <article><Zap size={13} /><strong>{previewMetric.renderMs.toFixed(1)} ms</strong><span>preview patch</span></article>
        <article><Radio size={13} /><strong>{firstTokenMs ? `${Math.round(firstTokenMs)} ms` : '—'}</strong><span>first token</span></article>
        <article><Gauge size={13} /><strong>{interactionMs.toFixed(1)} ms</strong><span>reconcile</span></article>
        <article><TimerReset size={13} /><strong>{historyDepth} / 40</strong><span>history depth</span></article>
      </div>
      <section className="budget-card">
        <div className="section-title-row"><span>Frame budget</span><small>{frameBudget.toFixed(0)}% used</small></div>
        <div className="budget-track"><i style={{ width: `${frameBudget}%` }} /></div>
        <p><span>{previewMetric.nodeCount} nodes</span><span>rev {previewMetric.revision}</span><span>isolated frame</span></p>
      </section>
      <section className="mutation-log">
        <div className="section-title-row"><span>Reconciliation trace</span><Activity size={12} /></div>
        {[...mutations].reverse().slice(0, 10).map((mutation) => (
          <div className="mutation-row" key={mutation.id}>
            <i className={`source-${mutation.source}`} />
            <div><strong>{mutation.label}</strong><small>{mutation.source}</small></div>
            <code>{mutation.durationMs.toFixed(1)} ms</code>
          </div>
        ))}
      </section>
    </div>
  )
}
